<main class="app-content">
  <div class="page-error tile">
    <h1><i class="fa fa-exclamation-circle"></i> Error 404: Page not found</h1>
    <p>The page you have requested is not found.</p>
    <p><a routerLink="/" class="btn btn-primary">Go Back Home</a></p>
  </div>
</main>